import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import { connect } from 'dva';
import FormCreate from '../../../../../../../components/FormCreate/index';
import styles from './index.less';

const formItemLayout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const { FormTitle, FormSelect, SenderUser } = FormCreate;

@connect(({ labelSetting, user }) => {
  return {
    currentUser: user.currentUser,
    ...labelSetting,
  };
})
class AddLabelModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = e => {
    e.preventDefault();
    const { form, fetchAddAndModifyLabel, isGroup, fetchAddAndModifyGroup, formData, currentTagData } = this.props;

    if (isGroup) {

      form.validateFields((err, values) => {
        if (err) {
          return;
        }
        const params = {
          ...values,
          id: formData && formData.id
        };
        fetchAddAndModifyGroup(params);
        // form.resetFields();
      });

    } else {
      form.validateFields((err, values) => {
        if (err) {
          return;
        }
        const params = {
          ...values,
          groupId: currentTagData.id,
          id: formData && formData.id
        };
        fetchAddAndModifyLabel(params);
        // form.resetFields();
      });
    }

  };

  handleCancel = () => {
    const { form } = this.props;
    const { dispatch } = this.props;
    dispatch({
      type: 'labelSetting/saveState',
      payload: { modalVisible: false, formData: {} },
    });
    form.resetFields();
  };


  renserGroupForm = () => {
    const { formData, form } = this.props;
    const { name = '' } = formData || {};
    const { getFieldsValue } = form;

    const titleProps = {
      form,
      value: name,
      label: '分组名称',
      keyName: 'name',
      maxLength: 10,
      suffix: `${(getFieldsValue().name && getFieldsValue().name.length) || name.length || 0}/10`,
    };
    return <FormTitle {...titleProps} />;
  };

  renderLabelForm = () => {
    const { formData, form, currentUser, currentTagData } = this.props;
    const { orgType } = currentUser || {};

    const { label = '', status = '0', selectid = '' } = formData || {};


    const { getFieldsValue } = form;
    const titleProps = {
      form,
      value: label,
      label: '标签名称',
      keyName: 'label',
      maxLength: 20,
      suffix: `${(getFieldsValue().label && getFieldsValue().label.length) || label.length || 0}/20`,
    };
    const groupProps = {
      form,
      value: currentTagData.name,
      label: '分组名称',
      keyName: 'currentTagData',
      disabled: true,
    };
    const selectStatusProps = {
      form,
      value: `${status}`,
      label: '状态',
      keyName: 'status',
      isRequired: true,
      optionData: [
        { value: '0', label: '使用' },
        { value: '1', label: '未使用' },
      ],
      placeholder: '请选择标签状态',
    };

    const selectUserProps = {
      form,
      value: selectid,
      appName: '宣传管理',
      appId: 71,
      orgType,
      isShowTagStudent: 0,
      label: "审批人",
      message: "请设置审批人",
      keyName: "selectid",
      isRequired: true,
    };

    return (
      <>
        <FormTitle {...titleProps} />
        <FormTitle {...groupProps} />
        <FormSelect {...selectStatusProps} />
        <SenderUser {...selectUserProps} />
      </>
    );
  };

  render() {
    const { modalTitle, modalVisible, isGroup } = this.props;


    return <>
      {
        modalVisible && <Modal
          title={modalTitle}
          visible={modalVisible}
          centered
          width={650}
          maskStyle={{ zIndex: 10 }}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          className={styles['add-form-labelSetting']}
          wrapClassName={styles['wrap-add-form-labelSetting']}
        >
          <FormCreate customerFormItemLayout={formItemLayout}>
            {isGroup ? this.renserGroupForm() : this.renderLabelForm()}
          </FormCreate>
        </Modal>
      }

    </>
  }
}

export default Form.create()(AddLabelModal);
